import React, { useRef, useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import api from "../../Utils/api";
import AgGridComponent from "../../Components/Common/AgGridComponent";
import Swal from "sweetalert2";
import { DeleteButton, EditButton } from "../../Components/Common/GridButton";

const emptyPartyName = {
  clarityMaster_id: 0,
  clarityMaster_Name: "",
};

export default function GenerateBag() {
  const [formData, setFormData] = useState(emptyPartyName);
  const [validated, setValidated] = useState(false);
  const CreateParty = useRef(null);
  const [clarityMasterData, setClarityMasterData] = useState([]);
  const [editClarityMasterData, setEditClarityMasterData] = useState(null);

  const NameInputRef = useRef(null);

  useEffect(() => {
    getClarityMasterData();
    if (NameInputRef.current) {
      NameInputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (editClarityMasterData) {
      setFormData({
        clarityMaster_id: editClarityMasterData.clarityMasterID,
        clarityMaster_Name: editClarityMasterData.clarityMasterName,
      });
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [editClarityMasterData]);

  const getClarityMasterData = () => {
    api
      .get("ClarityMaster/All")
      .then((result) => {
        setClarityMasterData(result.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const InsertClarityMaster = (event) => {
    ;
    setValidated(true);
    if (event) {
      event.preventDefault();
    }
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      return;
    } else {
      const data = {
        clarityMasterID: formData?.clarityMaster_id || 0,
        clarityMasterName: formData.clarityMaster_Name,
      };

      const endpoint =
        formData.clarityMaster_id === 0
          ? "ClarityMaster/InsertClarityMaster"
          : "ClarityMaster/EditClarityMaster";

      api[formData.clarityMaster_id === 0 ? "post" : "patch"](endpoint, data)
        .then((result) => {
          if (result.status === 200) {
            toast.success(result.data.message);
            getClarityMasterData(); // Refresh party data after successful insertion
            resetForm(); // Reset form after successful insertion
          } else {
            toast.error(result.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error("An error occurred");
        });
    }
  };

  const getClarityMaster = (id) => {
    ;
    api
      .get(`ClarityMaster/ByIDClarityMaster?ClarityMasterID=${id}`)
      .then((result) => {
        setEditClarityMasterData(result.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const DeleteClarityMaster = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to Delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {

        api
          .patch(`ClarityMaster/DeletePartyMaster?ClarityMasterID=${id}`)
          .then((result) => {
            if (result.status === 200) {
              Swal.fire({
                icon: "success",
                title: "Your record has been deleted.",
                showConfirmButton: false,
                timer: 1500,
              });
              getClarityMasterData();
            }
          })
          .catch((error) => {
            console.log(error);
            Swal.fire("Error", "An error occurred.", "error");
          });
      }
    });
  };

  const resetForm = () => {
    setFormData(emptyPartyName);
    setValidated(false);
  };

  const columnDefs = [
    {
      headerName: "Clarity Name",
      field: "clarityMasterName",
      flex: 1,
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Edit",
      width: 90,
      field: "clarityMasterID",
      cellStyle: { textAlign: "center" },
      headerClass: "centered-header",
      cellRenderer: ({ value }) => (
        <EditButton onClickHandler={() => getClarityMaster(value)} />
      ),
    },
    {
      headerName: "Delete",
      width: 90,
      field: "clarityMasterID",
      cellStyle: { textAlign: "center" },
      headerClass: "center-text widthTableColum",
      cellRenderer: ({ value }) => (
        <DeleteButton onClickHandler={() => DeleteClarityMaster(value)} />
      ),
      pinned: "right",
    },
  ];

  return (
    <>
      <ToastContainer />
      <Card>
        <Card.Header>
          <span>Clarity Master</span>
        </Card.Header>
        <Card.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={InsertClarityMaster}
            ref={CreateParty}
          >
            <Row>
              <Col md={6}>
                <div className="col-md-12 d-flex align-items-center mt-4">
                  <div className="col-md-4 col-sm-4 col-lg-4">
                    <Form.Group controlId="PartyName">
                      <Form.Label style={{ marginRight: "20px" }}>
                        Clarity Name :
                      </Form.Label>
                    </Form.Group>
                  </div>
                  <div className="col-md-8 col-sm-8 col-lg-8">
                    <Form.Group controlId="stoneTypeSelect">
                      <Form.Control
                        ref={NameInputRef}
                        type="text"
                        name="clarityMaster_Name"
                        placeholder="Enter ClarityName"
                        value={formData.clarityMaster_Name}
                        onChange={handleInputChange}
                        required

                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter The Value Clarity
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="card-footer margin_top10">
              <Button type="submit" variant="primary" className="mb-20px">
                {formData?.clarityMaster_id > 0 ? "Update" : "Save"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>

      <Card>
        <Card.Header>
          <span>Clarity Data</span>
        </Card.Header>
        <Card.Body>
          <AgGridComponent
            rowData={clarityMasterData}
            columnDefs={columnDefs}
            paginationPageSize={100}
            height="55vh"
          />
        </Card.Body>
      </Card>
    </>
  );
}
